import { useEffect, useState } from "react";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { storeReleasesEnumsValue } from "../../store/products/productsActions";
import { Typography } from "antd";
import { CloseIcon, DownArrowRelease } from "../../assets/images";
import Localize from "../../utils/string";
import { useHistory } from "react-router-dom";
interface Props {
  labelId?: any;
  productReleaseEnumValue?: any;
  setProductReleaseEnumValue?: any;
  scrollToTop?: any;
  setStartIndex?: any;
  rsdSpecialsVisible?: any;
  filterName?: any;
  closeFilter?: any;
  setFilterShow?: any;
  filterShow?: boolean;
  initialFunction?: any;
  filterLabelName?: any[];
  setSelectedWeekdays?: any;
  selectedWeekdays?: any;
  setSelectedYear?: any;
  weekdays?: any[];
  clearAllFilter?:any;
}

const formatComma = ["7", "10", "12"];

const ReleasesHeaderFilters = (Props: Props) => {
  const dispatch = useDispatch();
  const releases_enums_values: any = useSelector(
    (state: any) => state.products.releases_enums_values
  );
  const propsValues = releases_enums_values
    ? releases_enums_values
    : Props.productReleaseEnumValue;
  const store_redirect_path: any = useSelector(
    (state: any) => state.products.store_redirect_path
  );

  const loginResp = useSelector((state: any) => state.user.userSession);
  const history = useHistory();
  const handleClick = async (selectedOption: any) => {
    if(Props.selectedWeekdays.toString() === selectedOption.week.toString()) return;
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    params.set("weekNumber", selectedOption.week);
    params.set("weekYear", selectedOption.year);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    history.push(newUrl);
    Props.setSelectedWeekdays(selectedOption.week as number);
    Props.setSelectedYear(selectedOption.year as number);
    if (!Props.filterShow) {
      Props.initialFunction();
    }
  };

  // useEffect(() => {
  //   (async () => {

  //     dispatch(storeReleasesEnumsValue(0));

  //   })();

  //   return () => {
  //     // this now gets called when the component unmounts
  //   };
  // }, []);

  useEffect(() => {
    if (store_redirect_path === false) {
      // setProductReleaseEnumValue(1)
      dispatch(storeReleasesEnumsValue(1));
    }
  }, [store_redirect_path]);
  useEffect(() => {
    (async () => {
      // console.log("removable")
      // if (releases_enums_values) {
      //   Props.setProductReleaseEnumValue(releases_enums_values);
      //   const query = `?startIndex=1&pageSize=15&productReleaseEnumValue=${releases_enums_values}`;
      //   await dispatch(releasesFilter(query));
      // } else {
      //   dispatch(storeReleasesEnumsValue(0));
      // }
    })();

    return () => {
      // this now gets called when the component unmounts
    };
  }, [releases_enums_values]);

  return (
    <div className="links">
      <div className="links-inner">
        <Typography.Title
          onClick={() => {
            Props.filterShow !== null &&
              Props.filterShow &&
              Props.initialFunction();
            Props.setFilterShow((prev: boolean) => !prev);
          }}
          className={"activated-filter"}
          level={4}
        >
          Filters <span className={`${Props.filterShow ? 'arrow' : ''}`}><DownArrowRelease /></span>
        </Typography.Title>
        {/* !Props.filterShow && Props.filterName && */}
        {Props.filterName.length > 0  &&
          Props.filterName
            .map((filterName: string, index: number) => (
              <Button key={index} className={`rounded-btn selected`}>
                {formatComma.includes(filterName)
                  ? filterName + "”"
                  : filterName}
                {
                  <span
                    onClick={(event) => {
                      Props.closeFilter(event, false, index, filterName, true);
                    }}
                  >
                    <img
                      src={CloseIcon}
                      alt="close-icon"
                      height={"10px"}
                      width={"10px"}
                    />
                  </span>
                }
              </Button>
            ))}
        {Props.filterName.length > 1 && (
          <Button onClick={
            (event) => {
              Props.clearAllFilter(event);
            }
          } className={`rounded-btn selected clear-button`}>
            {"Clear All"}
            {/* {
              <span>
                <img
                  src={CloseIcon}
                  alt="close-icon"
                  height={"10px"}
                  width={"10px"}
                />
              </span>
            } */}
          </Button>
        )}
        {/* {propsValues !== 0 &&
          <>
            <Button
              className={`rounded-btn ${propsValues == 1 ? "selected" : ""
                }`}
              onClick={() => handleClick(1)}
            >
              {Localize.NewReleases}
            </Button>
            <Button
              className={`rounded-btn ${propsValues == 2 ? "selected" : ""
                }`}
              // className={`rounded-btn ${Props.productReleaseEnumValue == 2 || releases_enums_values == 2 ? "selected" : ""
              //   }`}
              onClick={() => handleClick(2)}
            >
              {Localize.ForthComing}
            </Button>
            <Button
              className={`rounded-btn ${propsValues == 3 ? "selected" : ""
                }`}
              // className={`rounded-btn ${Props.productReleaseEnumValue == 3 || releases_enums_values == 3 ? "selected" : ""
              //   }`}
              onClick={() => handleClick(3)}
            >
              {Localize.Represses}
            </Button>
          </>
        }
        {Props?.rsdSpecialsVisible === true && (
          <Button
            // className={`rounded-btn ${Props.productReleaseEnumValue == 5 || releases_enums_values == 5 ? "selected" : ""
            //   }`}
            className={`rounded-btn ${propsValues == 5 ? "selected" : ""
              }`}
            onClick={() => handleClick(5)}
          >
            {Localize.RsdSpecials}
          </Button>
        )} */}
      </div>
      {Props.weekdays && Props.weekdays.length > 0 && (
        <div className="release-week-filter-wrapper">
          <Typography.Title className="activated-filter">
            Release Week:
          </Typography.Title>
          <div className="week-days">
            {Props.weekdays &&
              Props.weekdays.length > 0 &&
              Props.weekdays.map((weekday, index) => (
                <div
                  onClick={() => handleClick(weekday)}
                  className={`${
                    weekday.week.toString() ===
                    Props.selectedWeekdays.toString()
                      ? "rounded-btn selected"
                      : ""
                  } week-day`}
                >
                  {weekday.week}
                  {weekday.week.toString() ===
                    Props.selectedWeekdays.toString() && (
                    <span
                      onClick={(event) => {
                        Props.closeFilter(
                          event,
                          false,
                          index,
                          weekday,
                          false,
                          true
                        );
                      }}
                    >
                      <img
                        src={CloseIcon}
                        alt="close-icon"
                        height={"10px"}
                        width={"10px"}
                      />
                    </span>
                  )}
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReleasesHeaderFilters;
